exports.convertStringArrayToObjectArray = values => {
  // keyValue pair does not work
  // const list = []
  // values.forEach(e => list[e+''] = e+'')
  // return list
  return values && values.length ? values.map(e => ({ 
    label: e+'',
    value: e+'',
  })) : []
}

exports.convertToDropDown = (values,keys) => {
  if(keys && keys.length){
    if(values && values.length){
      return values.map(e => ({
        label : `${e[keys[0]]}`,
        value : `${e[keys[0]]}`
      }))   
    } else{
      return [];
    } 
  }else{
    return [];
  } 
}

exports.getSelectedTemplate = (selectedTemp) => {
  return (
    {
    "cashAccPfId": selectedTemp.cashAccPfId,
    "cashAccNo": selectedTemp.cashAccNo,
    "amount": selectedTemp.amount,
    "remarks": selectedTemp.remarks,
    "costTypeKey": selectedTemp.costTypeKey,
    "currencyKey": selectedTemp.currencyKey,
    "currencyTech": selectedTemp.currencyTech,
    "beneficiaryId": selectedTemp.beneficiaryId,
    "toCashAccPfId": selectedTemp.toCashAccPfId,
    "toCashAccNo": selectedTemp.toCashAccNo
    })
}

exports.getModifiedTemplateObject = ({ amount, remarks, from, to, currency, cost, templateName}) => {
  const templateobj = { 
    "cashAccPfId": from.pfId,
    "cashAccNo": from.accNo,
    "amount": amount,
    "remarks": remarks,
    "costTypeKey": (cost && cost.costTypeKey)?cost.costTypeKey: null,
    "currencyKey": currency.currencyKey,
    "currencyTech": currency.tech,
    "beneficiaryId": to.beneficiaryId || null,
    "toCashAccPfId": to.pfId || null,
    "toCashAccNo": to.accNo || null
  }
  return templateobj;
}